// Import variables
import { LOGIN_SYSTEM_TYPES } from 'helpers/variables';

// Import hooks
import { useAppSelector } from 'store/hooks';

/**
 * Custom hook that checks what is user source/type (vectra | pureott)
 * This information is crutial when selecting prices and payments methods in transaction
 */
const useUserSourceType = () => {
	const user = useAppSelector(({ subscriber }) => subscriber.details);

	const source = user?.source;
	const { vectra, pureott } = LOGIN_SYSTEM_TYPES;

	const isAuthenticated = Boolean(user);

	const userSourceType = source;
	const isVectraUser = source === vectra;
	const isNexGenUser = source === pureott;
	const isRetailOrGuest = isNexGenUser || !isAuthenticated;

	return {
		userSourceType,
		isVectraUser,
		isNexGenUser,
		isRetailOrGuest,
		isAuthenticated
	};
};

export default useUserSourceType;
